import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			Por tiuj, kiuj amas ĉion verdan kaj vivantan, klubo estas la plej natura kaj ofta formo de kunvivado. 
			Kaj la klubon mem oni facile povas percepti kiel ion vivantan: ĝi embriiĝas (ne ebriiĝas!), ĝermas, naskiĝas, kreskas, floras kaj velkas, falas forhakita aŭ putras starante, seke elstaras aŭ kuŝas trunke, sed post la sukcesa vivo el kreitaj de li semoj elkreskas novaj klub(id)oj. 
			Reproduktiĝas kluboj ofte vegetative; tamen okazas iam naskiĝo de unu klubo el la sino de alia, la turmentiga procezo, kutime konsiderata de ĝiaj partoprenantoj kiel konflikto kun skismo. 
			Ni devas agnoski tamen, ke ankaŭ veraj skismaj malsanoj povas okazi kaj rezultigi, tute male, la morton de la klubo.
		</p>
		
		<p class="mb-3">
			Por kreskigi bonan klubon, oni devas posedi aŭ talenton kaj intuicion, aŭ (prefere, certe, ne aŭ, sed ambaŭ) la sperton kaj sciojn, la eta parto de kiuj troviĝas en ĉi-teksto, sed alio – en lernolibroj kaj monografioj pri klubologio, sociala psikologio, sociologio kaj eĉ iom-maliom en filozofio.
		</p>
		
		<p class="mb-3">
			Ĝuste ĉe granda filozofo Gegel, kiun ni, sen lia permeso, ekkonsideris unu el fontoj de Miasmo, troviĝas la nocio «klubo» en preskaŭ moderna senco. 
			La sociologoj nomas tion «socia unuiĝo», socialaj psikologoj – «neformala grupo». 
			Tiu malnovulo, kiu samtempanis kelkajn klubojn, certe konsentos, ke la klubo ne estas superporda ŝildo, kaj eĉ ne ejo-subtenejo sub ĝi, sed unuavice homoj, aŭ, pli ĝuste dirante, speciala sistemo de rilatoj en malgranda grupo de homoj, kiun klubanoj nomas «la kerno de la klubo».
		</p>
		
		<p class="mb-3">
			Specialeco de tiuj rilatoj kuŝas, unue, en ilia MEMVOLECO (ne konfuzu kun demokratio). 
			Laŭ la stilo de gvidado kluboj povas esti kaj foj-foje estas absolute aŭtokratecaj, dum regopovo de gvidanto povas fonti el tute psikologiaj (nekontestebla prestiĝo), same kiel el plene materiaj kondiĉoj (posedo de klubaj resursoj, ekz., ejo). 
			Unu bonega kreanto de kluboj ŝatis diradi: «La kluba demokratio signifas: memvole vi venis, -- memvole vi obeu al la klubaj leĝoj; se ne – do memvole vi foriru».
		</p>
		
		<p class="mb-3">
			Do, ni havas memvolecon en la senco de libera elekto; sed tio ja ne sufiĉas. 
			En libera socio oni povas elekti kaj loĝlokon, kaj laboron, sed tio ne egaligas klubon de bieramantoj kaj bieruzinon. 
			Por kiu biero??! -- jen esenca demando. 
			Se la produktantoj mem konsumas ĝin, do ni vidas ne uzinon, sed ĝuste la klubon: memvolan unuiĝon de homoj, kiu estis kreita por senpera kontentigo de iliaj propraj bezonoj. 
			La plimulto de reale ekzistantaj kluboj kontentigas, certe, ne karnajn, sed spiritajn bezonojn de homoj. Interesa specialaĵo de kelkaj kluboj estas nekorekta percepto far iliaj membroj de sia propra agado: tiel, la teatra klubo opinias sin mem teatro, aŭ la klubo de prahomserĉantoj – ekspedicio. 
			La veron oni facile konjektas laŭ la nombro de spektantoj kaj trovitaj prahomoj. 
			Lastatempe iĝis modo krei diskutklubojn sub aspekto de politikaj partioj.
		</p>
		
		<p class="mb-3">
			La plej disvastigita eraro inter nespertaj klubkreantoj estas la sekva: «Ni povas krei bonan klubon de krokodilamantoj, ĉar ni ĉiuj ŝatas krokodilojn». 
			Laŭsence kaj laŭesence, aplikendas ĉi tie la klasika suspekto de la Porkido antaŭ la vizito al Elefantopotamo: «Ĉu ŝatas Elefantopotamo porkidojn, kaj se jes, do KIAMANIERE ĝi ilin ŝatas?».
		</p>
		
		<p class="mb-3">
			Antaŭ ol elspezi por estonta klubo siajn fortojn, rimedojn kaj monon, antaŭ ol peti la samon ĉe eventualaj monhelpantoj kaj oficialuloj, promesante al ili reklamon kaj bonan statistikon (kaj por monhelpantoj kaj oficialuloj – antaŭ ol doni ion), estus bezonate klarigi pli precize por si mem tiun KIAMANIERE.
		</p>
		
		<p class="mb-3">
			Inter kvinopo de krokodilamantoj povas tre verŝajne okazi, ke…
		</p>

		<ul class="no-dots-list">
			<li>
				la UNUA volas scii pli multe pri krokodiloj (ho, kiu proksima al koro de ĉiu esperantisto temo!). 
				Ŝli bezonas bibliotekon, komputilon kun donitaĵaro kaj oficvojaĝon al natura krokodilejo (ĉu UK?).
			</li>
			<li>
				la DUA jam havas krokodilon kaj volas dresi ĝin. 
				Ŝli bezonas basenon kaj antilopojn.
			</li>
			<li>
				la TRIA volas elbredi novajn rasojn de krokodiloj. 
				Ŝli bezonas elektronan mikroskopon kaj gamma-elradiilon.
			</li>
			<li>
				la KVARA deziras plibonigi homojn, sur grundo de kunesto kun krokodilo. 
				Ŝli bezonas krokodilon kaj grupon de volontuloj.
			</li>
			<li>
				kaj fine, la KVINA ŝatas babiladi pri krokodiloj, precipe kun personoj de alia sekso. 
				Ŝli bezonas seĝojn, tablon kaj te-ajaron.
			</li>
		</ul>

		<p class="mb-3">
			Vi povas eĉ ne dubi, ke tiuj kvin ne kreos la klubon, ĉar sur la sama bazo de ENHAVO DE AGADO ili provas konstrui diversajn SOCIALAJN TIPOJN de kluboj, destinitajn por kontentigo de diversaj homaj bezonoj.
		</p>
		
		<ul class="no-dots-list">
			<li>
				La UNUA klubo kontentigas PASIVAN ESTETIKAN BEZONON je arto, scioj, kuniĝo kun naturo.
			</li>
			<li>
				La DUA kaj TRIA estas lokoj, kie homo povas realigi sian krean potencon, kontentigi AKTIVAN ESTETIKAN BEZONON.
			</li>
			<li>
				La KVARA estas destinita por memperfektiĝo en, verŝajne, MORALA-ETIKA sfero.
			</li>
			<li>
				La KVINA klubo estas fonto de la sola vera valoregaĵo, laŭ opinio de A. de Saint-Exuperie, – la trezoro de homa interkomunikiĝo. 
				Tio estas la plej disvastigita kaj la plej facile atingebla tipo de kluboj. 
				Interalie, al ĝi poiomete transformiĝadas ĉiuj aliaj tipoj dank’ al entropio, aŭ pli simple dirante – pro maljuneco kaj pigreco.
			</li>
		</ul>
		
		<p class="mb-3">
			La dua sufiĉe ofta misopinio: ke oni povas ĉion tion samtempe samloke kunigi. 
			Do, en baseno naĝas krokodiloj kaj metas sub mikroskopon jam priradiitajn ovojn; kaj sur la bordo, apud samovaro kaj komputilo, la klubanoj interkomunikiĝas kun krokodiloj kaj inter si mem.
		</p>
		
		<p class="mb-3">
			Sed praktike ja, normalaj homoj eĉ en riĉa Okcidento (ege pli okcidente ol Odessa!), eĉ kun la helpo de ŝtato aŭ monliverantoj apenaŭ amasigos rimedojn por ĉio kune. 
			Se, ezemple, sufiĉos mono por aĉeti unu krokodilon kaj lui la banĉambron por ĝi, do por komputilo kaj libroj tie estos tro humide, kaj por teuma komunikado – tro malvaste.
		</p>
		
		<p class="mb-5">
			Tio, certe, ne signifas, ke homaj rilatoj tute forestas. 
			En ĉiu klubo, pli aŭ malpli okazas kaj memesprimo, kaj memperfektiĝo, kaj konatiĝo kun estonta familio. 
			Sed io sola ĉiam, malgraŭ volo kaj plaĉo, iĝas la ĉefa, elpremante aliujn, kaj la procezo de elekto povas transformi iun ajn klubon al la klubo de konfliktamantoj. 
			Se vi ne volas tion, do alkonformigu, kiel ĉiam en la vivo, viajn dezirojn al viaj eblecoj, kaj elektu ion solan.
			</p>

		<p class="mb-3">
			Do, nun ĉe ni estas difinita ne nur ENHAVO, sed ankaŭ SOCIALA TIPO de via klubo. 
			Venis tempo pripensi pri ĝia SOCIOTEKNIKA FORMO: kiom da personoj konsistigos la klubon, kiam kaj kiel ili renkontiĝados, kiun oni akceptas aŭ ne akceptas al klubanoj ktp. 
			La ĉefa parametro de socioteknika formo – la GRADO DE MALFERMITECO de la klubo: depende de ĝi la gamo de diversaj formoj estas distribuita inter du randaj variantoj. 
			Ni nomu ilin: modelo «Tramo» kaj modelo «Aviadilo».
		</p>
		
		<p class="mb-3">
			Por la Tramo, ekapero de la klubo estas komenco de movado; en ĉiu kluba kunsido (haltejo) la pordoj malfermiĝas por ĉiuj, kiuj deziras en- aŭ eliri. 
			Nur la stiristo kaj malgranda parto da pasaĝeroj veturas de komenco ĝis la fino; la plejparto de vizitantoj de la klubo estas homoj sendependaj kaj per nenio fikse ligitaj al la klubo.
		</p>
		
		<p class="mb-3">
			La Aviadilo tamen estas malfermita nur antaŭ ekflugo; post la terlaso neniu nova povas tien trafi. 
			La «fermiteco» estas garantiata per sistemo de aneco, aŭ simple per solidareco de unuigita kolektivo, kiu forpuŝas fremdulojn. 
			Male, por kreo de «malfermiteco» estas necesaj reklamo kaj bonkoreco al vizitantoj.
		</p>
		
		<p class="mb-3">
			La klubo-«aviadilo» kutime entenas 8-15 personojn, kaj dum ĝiaj raraj «alteriĝoj» proksimume 80-100 personoj entute povas trairi tra ĝi. 
			En la «tramon» povas eniri per unu fojo eĉ 30, kaj dum la tuta tempo de ĝia ekzistado miloj kaj eĉ dekoj da miloj da interesantoj. 
			La malfermita klubo reprezentas AMASECON, la fermita – EFEKTIVECON. 
			Tramo estas malkara, ĝi veturigas multajn, sed malrapide kaj nemalproksimen; aviadilo tamen – alten kaj malproksimen, sed pli malmultajn kaj pli multekoste.
		</p>
		
		<p class="mb-5">
			Sed kio estas stranga, ambaŭ veturigas onin samtempe, sed laŭ diversaj itineroj kaj al diversaj lokoj. 
			Ĉiu homo kun helpo de klubo translokiĝas al alia loko de si mem, en alian staton de sia animo. 
			Ŝli trovas novan aspekton de sia personeco, – kaj ĝuste por tio estas necesaj la kluboj, ĝuste tiu estas ilia funkcio en la socio.
		</p>

		<p class="mb-3">
			Jen ankoraŭ kelkaj koncizaj konsiloj por luantoj kaj luigantoj de kluboj kaj kluba aĵaro.
		</p>
		
		<p class="mb-3">
			Plenforta kaj plenvalora klubo povas elkreski nur en aparta ĉambro. 
			Tio estas tre malfacile ĉe nia nuna mizereco, sed eblas, ekzemple, duonigi ejon per lignaj vandoj. 
			Pli celkonforme estas ŝpari je io alia, ekz., je volumeno kaj kvalito de riparo, je aĵaro.
		</p>
		
		<p class="mb-3">
			Pli facile najbaras kluboj de diversaj enhavoj, sed la sama sociala tipo. 
			Ne devigu du ekologiajn klubojn uzadi unusaman fotopafilon: ili kulpigos unu la alian pri ŝtelĉasado. 
			Kaj male, klubo de ŝatantoj babiladi pri kino tute amike dividos videomagnetofonon kun klubo de ŝatantoj babiladi pri sekso (kaj klubo de ŝatantoj babiladi pri Esperanto en sia nacia lingvo povas unuiĝi kun ajna babilklubo, ĉu ne?).
		</p>
		
		<p class="mb-5">
			La daŭro kaj efektiva vivo de bona klubo varias de 3 ĝis 6 jaroj. 
			Ĝi dependas de la aĝo (infanaj kluboj vivas pli mallonge) kaj de la intenseco de interkomunikado (certe, pli longe vivos tiu klubo, kies anoj pli malofte renkontiĝas).
		</p>

		<p class="mb-3">
			Kaj la lasta, la plej grava konsilo: kiaj ajn fidindaj ŝajnus al vi la ĉi-supraj konsiloj, neniuokaze uzu ilin, se almenaŭ iomete ili ne trovas plaĉon ĉe vi. 
			Memoru, ke vi ne estas sur laborloko! En klubo vi ne devas ĉiam agi korekte. 
			La klubo, – ĝi estas por animo.
		</p>
		`
	)
}

const itemName = {
	esp: 'Kiamaniere kreskigi klubon'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: `
			<p class="italic">
				tradukis el la rusa <br/>
				Miĥail Kordonskij (Odessa).
			</p>
		`
	}
}

export default item;